
import { ElForm } from 'element-ui/types/form'
import { Component, Vue } from 'vue-property-decorator'
import { CommonService } from '@/services/index'

enum PLATFORM {
    IOS = 'ios',
    ANDROID = 'android'
}

@Component({})
export default class extends Vue {
    private isLoading: boolean = false
    private platform: PLATFORM = PLATFORM.ANDROID
    private refForm?: ElForm
    private versionForm: any = {
        version: '',
        url: '',
        url_huawei: '',
        option1: '',
        option2: '',
        option3: '',
        option4: '',
        approved: '-1',
        createTime: '',
        updateTime: ''
    }

    private rules: any = {
        version: [
            { required: true, validator: this.checkVersion }
        ],
        url: [
            { required: true, message: '该项为必填' }
        ],
        url_huawei: [
            { required: true, message: '该项为必填' }
        ],
        option1: [
            { required: true, message: '该项为必填' }
        ],
        approved: [
            { required: true, message: '该项为必选项' }
        ]
    }

    private checkVersion(rule: any, value: string, callback: Function) {
        const reg = /^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/
        if (!reg.test(value)) {
            callback('请填写正确的版本号')
        } else {
            callback()
        }
    }

    private mounted() {
        this.init()
        this.getVersionInfo()  
    }

    private init() {
        const { p: platform } = this.$route.query
        this.platform = platform ? platform === PLATFORM.IOS ? PLATFORM.IOS : PLATFORM.ANDROID : PLATFORM.ANDROID
        this.refForm = this.$refs.verisonForm as ElForm
    }

    private async getVersionInfo() {
        this.isLoading = true
        this.resetForm()
        // 写接口逻辑
        const result = await CommonService.getAppVersionInfo({ system: this.platform })
        this.isLoading = false
        if (result.status === 200) {
            let { content, version, url, url_huawei, is_approved, update_time, create_time } = result.data
            this.versionForm.version = version
            this.versionForm.url = url
            this.versionForm.url_huawei = url_huawei
            this.versionForm.approved = String(+is_approved)
            this.versionForm.updateTime = update_time
            this.versionForm.createTime = create_time
            if (content) {
                content = JSON.parse(content)
                content.forEach((value: string, index: number) => {
                    this.versionForm['option'+(index+1)] = value  
                })
            }
            return
        }
        this.$message.error(JSON.stringify(result.message) || '获取版本信息失败')
    }

    private async updateVersionInfo() {
        this.isLoading = true
        const content: string[] = []
        Reflect.ownKeys(this.versionForm).forEach((key) => {
            if (key.toString().includes('option')) {
                const value = this.versionForm[key]
                value && content.push(value)
            }
        })
        const params = {
            system: this.platform,
            version: this.versionForm.version,
            content: JSON.stringify(content),
            url: this.versionForm.url,
            url_huawei: this.versionForm.url_huawei,
            is_approved: !!+this.versionForm.approved
        }
        const result = await CommonService.updateAppVersion(params)
        this.isLoading = false
        if (result.status === 200) {
            // this.getVersionInfo()
            this.$message({
                message: `更新 ${this.platform} APP 版本信息成功`,
                type: 'success'
            })
            return (this.$refs.backTop as any).scrollToTop()
        }
        this.$message.error(JSON.stringify(result.message) || '更新版本信息失败')
    }

    private onRadioChange(label: string) {
        const url = this.$route.path
        this.resetForm()
        this.$router.replace(`${url}?p=${label}`)
        this.getVersionInfo()
    }

    private submitForm(formName: string) {
        (this.$refs[formName] as ElForm).validate((valid: boolean) => {
            if (valid) {
                this.updateVersionInfo()
            } else {
                return false
            }
        })
    }

    private resetForm() {
        this.refForm!.resetFields()
    }
}
